export const brandKeywordEndPoint = 'brand-keywords';
